import getNewsletters from '@api/routes/newsletter-archive/GetNewsletters/';

let VCA = VCA || {};

VCA.NewsletterStories = (function ($) {
    var ui = {};
    let activePage = 1;
    let totalPagesOnLoad = '';

    function cacheUI() {
        ui.loader = $('.newsletters-list__loader');
    }

    function initNewsletterGet(params) {
        if ($('#newsletters').length <= 0) {
            return;
        }

        if(window.location.href.match(/\?./)){
            const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));

            for(const [ key, value ] of urlParams.entries()){
                if(key == 'page'){
                    activePage = value;
                }
            }
        }

        totalPagesOnLoad = $('#TotalPages').data('total-page');
        getAPIData(activePage);
    }

    function selectPage(e) {
        e.preventDefault();
        let selectedPage = $(e.currentTarget).data('page');
        $('#newsletters')[0].scrollIntoView({ behavior: 'smooth' })
        getAPIData(selectedPage);
    }

    function  updateURL(page) {
        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search)
            searchParams.set("page", page);
            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }
    }

    async function getAPIData(selectedPage) {
        let errMsgContainer = $('.newsletter-list-error');
        let errorMessage = $('.newsletter-list-error__error-msg');
        let paginationBar = $('.vca-voice-current__pagination-container');
        ui.loader.show();

        $(errMsgContainer).addClass('hidden');

        let params = {page:selectedPage}
        const { data, success, error } = await getNewsletters.query(params);

        if(!success || data.IsSuccess == false ){
            emptyResultsContainer();
                $(paginationBar).addClass('hidden');
                $(errorMessage).text('No results were found.')
                $(errMsgContainer).removeClass('hidden');
                ui.loader.hide();
            return;
        }else{
            let totalPages = data.TotalPages;
            let stories = data.NewsletterArticles;
            $(paginationBar).removeClass('hidden');
            emptyResultsContainer();
            $('#VoiceTotalPagesNum').html(totalPages);
            createCards(stories, totalPages, selectedPage);
            updateURL(selectedPage);
            ui.loader.hide();
        }
    }

    function emptyResultsContainer() {
        $('#newsletters .newsletters-list__list').empty();
    }

    function createCards(results, totalPages, selectedPage) {

        let articles = results;
        let totalNumOfPages = totalPages;

        let element = document.querySelector("#CurrentStoriesPagination ul");
        let page = selectedPage;
        element.innerHTML = createPagination(totalNumOfPages, page);
        $('.pagination-bar__pagination-btn').each(function () {
            $(this).on('click', selectPage);
        });

        for (let i = 0; i < articles.length; i++) {
            let story = articles[i];
            let hasImage = "";
            let hasDescription = "";
            if(story.ImageUrl == null || story.ImageUrl == '' ) {
                hasImage = 'hidden';
            }
            if(story.Description == null || story.Description == '' ) {
                hasDescription = 'hidden';
            }
            let storyCard = $(`
                <li class="newsletters-list__item bg-color-vca-whisper">
                    <div class="newsletters-list__item__image ${hasImage}">
                        <img alt="${story.ImageAlt}" src="${story.ImageUrl}" />
                    </div>
                    <div class="newsletters-list__item__content">
                        <div class="newsletters-list__item__title h4"><a href="${story.URL}">${story.Title} | ${story.Date}</a></div>
                        <div class="newsletters-list__item__desc ${hasDescription}">${story.Description}</div>
                    </div>
                </li>
            `);

            $('#newsletters .newsletters-list__list').append(storyCard);
        }
    }

    function createPagination(totalPages, pages) {
        let liTag = '';
        let active;
        let page = parseInt(pages);
        let beforePage = parseInt(pages) - 1;
        let afterPage = parseInt(pages) + 1;
        let element = document.querySelector("#CurrentStoriesPagination ul");
        let path = 'press-center/vca-news';

        if (page > 1) {
            liTag += `<li><a href="/${path}?page=${page - 1}" class="pagination-bar__pagination-btn prev-btn prev" data-page="${page - 1}"><span>Prev</span></a></li>`;
        } else if (page == 1) {
            liTag += `<li><a href="/${path}?page=${page}" class="pagination-bar__pagination-btn prev-btn prev disabled" data-page="${page}"><span>Prev</span></a></li>`;
        }

        if(page > 2){ 
            if (totalPages >= 5) {
                liTag += `<li><a href="/${path}?page=1" class="pagination-bar__pagination-btn first numb" data-page="1"><span>1</span></a></li>`;
            }
          if(page > 3 && totalPages > 5){ 
            liTag += `<li class="vca-voice-current__dots dots"><span>...</span></li>`;
          }
        }
        // how many pages or li show before the current li
        if (page == totalPages) {
            beforePage = beforePage - 2;
        } else if (page == totalPages - 1) {
          beforePage = beforePage - 1; 
        }

        if (beforePage < 0) {
            beforePage = 0;
        }
        // how many pages or li show after the current li
        if (page == 1) {
            afterPage = afterPage + 2;
        } else if (page == 2) {
            afterPage = afterPage + 1;
        }
        for (let plength = beforePage; plength <= afterPage; plength++) {
            if (plength > totalPages) { //if plength is greater than totalPage length then continue
                continue;
            }
            if (plength == 0) { //if plength is 0 than add +1 in plength value
                plength = plength + 1;
            }
            if (page == plength) { //if page is equal to plength than assign active string in the active variable
                active = "active";
            } else { //else leave empty to the active variable
                active = "";
            }
            liTag += `<li><a href="/${path}?page=${plength}" class="pagination-bar__pagination-btn numb ${active}"data-page="${plength}"><span>${plength}</span></a></li>`;
        }

        if (page < totalPages - 1) { //if page value is less than totalPage value by -1 then show the last li or page 
          if (page < totalPages - 2 && totalPages > 5) { //if page value is less than totalPage value by -2 then add this (...) before the last li or page 
            liTag += `<li class="vca-voice-current__dots dots"><span>...</span></li>`;
          }
          if (totalPages >= 5) {
            liTag += `<li><a href="/${path}?page=${totalPages}" class="pagination-bar__pagination-btn last numb" data-page="${totalPages}"><span>${totalPages}</span></a></li>`;
          }
        }

        if (page <= totalPages) { //show the next button if the page value is less than totalPage 
            if (page < totalPages) { 
                liTag += `<li><a href="/${path}?page=${page + 1}" class="pagination-bar__pagination-btn next-btn next" data-page="${page + 1}"><span>Next</span></a></li>`;
            } else if (page == totalPages) { 
                liTag += `<li><a href="/${path}?page=${page}" class="pagination-bar__pagination-btn next-btn next disabled" data-page="${page}"><span>Next</span></a></li>`;
            }
        }

        element.innerHTML = liTag; //add li tag inside ul tag
        $('#VoiceCurrentPageNum').text(page);
        return liTag; 
    }

    function init() {
        cacheUI();
        initNewsletterGet();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.NewsletterStories.init();
});

